import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import storycraftLogo from "@/assets/storycraft-logo-new.png";

export const Navbar = () => {
  return (
    <nav className="fixed top-[36px] left-0 right-0 z-50" style={{ background: 'rgba(250, 250, 250, 0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #E5E7EB' }}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img src={storycraftLogo} alt="AI StoryCraft Studio" className="w-10 h-10 rounded-xl object-contain" />
            <span className="font-display text-lg font-bold hidden lg:block" style={{ color: "#111827" }}>
              AI StoryCraft <span style={{ color: '#F59E0B' }}>Studio</span>
            </span>
          </Link>
          <div className="flex items-center gap-3 sm:gap-4">
            <Button variant="ghost" size="sm" asChild className="text-foreground hover:bg-gray-100">
              <Link to="/auth">Login</Link>
            </Button>
            <Button size="sm" asChild className="bg-[#7C3AED] text-white font-bold hover:bg-[#6D28D9] border-none">
              <a href="#pricing">Start Free Trial</a>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
